import { cn } from '../../lib/utils'
import Image from 'next/image'
import Link from 'next/link'

export const Logo = ({ className }: { className?: string }) => {
    return (
        <div className={cn('flex items-center gap-2', className)}>
            <LogoIcon />
            <span className="text-sm font-bold tracking-wide text-black">LUMMENY</span>
        </div>
    )
}

export const LogoLink = ({ className }: { className?: string }) => {
    return (
        <Link
            className={className}
            href="/">
            <Logo />
        </Link>
    )
}

export const LogoIcon = ({ className }: { className?: string }) => {
    return (
        <div className={cn('flex h-7 w-7 items-center justify-center rounded-md', className)}>
            <Image
                src="/logo.svg"
                alt="Lummeny"
                width={24}
                height={24}
            />
        </div>
    )
}
